
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 32 32","fill":"none","xmlns":"http://www.w3.org/2000/svg","aria-hidden":"true"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M9.5 2.286c-.644 0-1.167.511-1.167 1.143V4.57h16.334V3.43c0-.632-.523-1.143-1.167-1.143h-14zM27 3.429C27 1.535 25.433 0 23.5 0h-14C7.567 0 6 1.535 6 3.429V28.57C6 30.465 7.567 32 9.5 32h14c1.933 0 3.5-1.535 3.5-3.429V3.43zm-2.333 3.428H8.333v18.286h16.334V6.857zm0 20.572H8.333v1.142c0 .632.523 1.143 1.167 1.143h14c.644 0 1.167-.511 1.167-1.143V27.43z","fill":"currentColor"}})])
          )
        }
      }
    